
    var riot = require('riot')
    
riot.tag2('teamadmin', '<div class="teamadmin"> <div class="row"> <div class="col-xs-12"> <div if="{orghash}" class="alert alert-info"> <p>If you would like other people to sign up and be linked with your team, give them the following <a href="https://www.nafems.org/system/sign_up/?ref={orghash}">link </a></p> <pre><code>https://www.nafems.org/system/sign_up/?ref={orghash}</code></pre> </div> </div> <div class="col-xs-12"> <ul class="nav nav-tabs"> <li class="{active:tab==\'members\'}"><a href="#" onclick="{settab}" name="members">Team Members</a></li> <li class="{active:tab==\'invoices\'}"><a href="#" onclick="{settab}" name="invoices"> Team Invoices</a></li> <li class="{active:tab==\'credits\'}"><a href="#" onclick="{settab}" name="credits"> Credits</a></li> </ul> </div> </div> <div if="{tab==\'credits\'}" class="row"> <div class="col-xs-12"> <div class="alert"> <p>Your account has <strong>{credits} {cridits == 1 ? ⁗Credit⁗ : ⁗Credits⁗}</strong> available. </p> </div> <div class="alert alert-info"> <label> <input type="checkbox" __checked="{notify_credits}" oninput="{updateNotify}"> </label> Notify Me By Email When Credits Are Used </div> </div> </div> <div if="{tab==\'invoices\'}" class="row"> <div class="col-xs-12"> <table class="table table-striped"> <thead> <tr> <th>Invoice Num.</th> <th>Billing Name</th> <th>Billing Postcode</th> <th>Date</th> <th>Paid</th> <th>Amount</th> </tr> </thead> <tbody> <tr each="{page_invoices}" onclick="{get_invoice}" class="{selected:parent.user.id==id}"> <td>{reference}</td> <td>{billing_name}</td> <td>{billing_postcode}</td> <td> <dateformat date="{created_at}" format="d MMM yyyy h:mm a"></dateformat> </td> <td>{confirmed ? ⁗Yes⁗ : ⁗No⁗}</td> <td>{parent.getCurrency(basketdata)}{amount}</td> </tr> </tbody> </table> <pagination data="{invoices}" max="10" updatepages="{makeinv_page}"></pagination> </div> </div> <div if="{tab==\'members\'}" class="row"> <div class="col-xs-12"> <table class="table table-striped"> <thead> <tr> <th>First Name</th> <th>Surname</th> <th>Email</th> <th class="col-md-2">Can Use Credits?</th> </tr> </thead> <tbody> <tr each="{team}" onclick="{get}" class="{selected:parent.user.id==id}"> <td>{first_name}</td> <td>{surname}</td> <td>{email}</td> <td class="text-center"><span class="{use_credits ? \'fa fa-check text-success\' : \'fa fa-times text-danger\'}"></span></td> </tr> </tbody> </table> <div if="{!loading &amp;&amp; !user}" class="btn-toolbar pull-right"> <button onclick="{add}" class="btn btn-primary">Add Team Member</button> </div> <div if="{loading}" class="alert alert-info"> <p> <span class="fa fa-refresh fa-spin fa-fw"> </span>Loading</p> </div> <formhorizontal width1="2" width2="10" if="{user}" submit="{save}"> <hr> <h3>Member Details</h3> <formstatic label="Email Address" value="{parent.user.email}" if="{parent.user.id}"></formstatic> <forminput label="Email Address" name="email" value="{parent.user.email}" if="{!parent.user.id}" oninput="{parent.userupdate}" isrequired="" autocomplete="nope"></forminput> <forminput label="First Name" name="first_name" isrequired="" value="{parent.user.first_name}" oninput="{parent.userupdate}"></forminput> <forminput label="Surname" name="surname" isrequired="" value="{parent.user.surname}" oninput="{parent.userupdate}"></forminput> <formtextarea label="Address" name="address" value="{parent.user.address}" oninput="{parent.userupdate}"></formtextarea> <formselect name="state" label="State" oninput="{parent.userupdate}" value="{parent.user.state}" options="{parent.stateCodes}" default="Select State" show="{parent.user.country==\'US\'}"></formselect> <forminput name="postcode" label="Post/Zip Code" oninput="{parent.userupdate}" value="{parent.user.postcode}"></forminput> <formselect name="country" label="Country" oninput="{parent.userupdate}" value="{parent.user.country}" options="{parent.countryCodes}" default="Select Country"></formselect> <forminput label="Phone" name="phone1" value="{parent.user.phone1}" oninput="{parent.userupdate}"></forminput> <formcheckbox label="Can Use Credits?" name="use_credits" type="checkbox" value="{parent.user.use_credits}" oninput="{parent.userupdate}"></formcheckbox> <forminput label="New Password" type="password" placeholder="Please leave blank, unless your wish to update" name="newpassword" autocomplete="new-password" value="{parent.password}" oninput="{parent.passupdate}"></forminput> <formcheckbox label="Send Invite Email?" name="sendinvite" type="checkbox" value="{parent.user.sendinvite}" oninput="{parent.userupdate}"></formcheckbox> <forminput if="{parent.password}" label="Confirm Password" type="password" autocomplete="new-password" placeholder="Please repeat above password" name="newpassword" value="{parent.password2}" oninput="{parent.passupdate2}"></forminput> <div if="{parent.password &amp;&amp; (parent.password!=parent.password2 || parent.password.length &lt; 8)}" class="alert alert-danger"> <p>Please ensure both passwords are the same and are over 7 characters long</p> </div> <div class="btn-toolbar"> <div class="pull-left btn-toolbar"> <confirm placement="top" onconfirm="{parent.remove}" title="Deleting this user will remove their login to nafems.org and all transaction history. This cannot be undone. Are you sure?" class="btn btn-danger">Delete This Member</confirm> </div> <div class="pull-right btn-toolbar"> <button onclick="{parent.close}" class="btn btn-default">Close </button> <button type="submit" __disabled="{parent.saving}" class="btn btn-primary">{parent.saving ? ⁗Saving⁗ : ⁗Save Changes⁗}</button> </div> </div><br> <div class="alert alert-info"> <p>Any changes made to Member Details may require the member to sign out and back in again to take effect.</p> </div> </formhorizontal> <div class="row"> <div class="col-xs-12"><br> <div if="{err}" class="alert alert-danger"> <p>{err.message}</p> </div> </div> </div> <p> <br></p> </div> </div> </div>', '.teamadmin tbody tr:hover td { background-color: #ddd; cursor: pointer; } .teamadmin .table.table-striped > tbody > tr.selected > td { background-color: #2d2e4e; border: 1px solid #2d2e4e; color: #fff; } .teamadmin .formButton { padding: 5px 10px; border: 1px solid #ddd; margin: 3px; } .teamadmin .formButton.active { border: 1px solid #2d2e4e; } .teamadmin .nav-tabs > li { margin-bottom: -1px; }', '', function(opts) {
var Resource, countryApi, inv_resource, resource, stateApi, xhr;

xhr = require("../libs/xhr.coffee");

Resource = require('riot-kit/utils/apiResource.coffee');

resource = new Resource('/duocms/api/team', true);

countryApi = new Resource(opts.countrysrc || '/duocms/api/countries', true);

stateApi = new Resource(opts.statesrc || '/duocms/api/states', true);

inv_resource = new Resource('/duocms/api/team_invoices', true);

this.password = null;

this.tab = "members";

this.countryCodes = [];

this.stateCodes = [];

this.orghash = "";

this.on("mount", function() {
  this.loadlist();
  this.loadinvoices();
  this.getCredits();
  countryApi.get((function(_this) {
    return function(countries) {
      _this.countryCodes = countries.map(function(country) {
        return {
          label: country.name,
          value: country.code
        };
      });
      return _this.update();
    };
  })(this));
  return stateApi.get((function(_this) {
    return function(states) {
      _this.stateCodes = states.map(function(state) {
        return {
          label: state.name,
          value: state.code
        };
      });
      return _this.update();
    };
  })(this));
});

this.getCredits = (function(_this) {
  return function() {
    var credits, data;
    credits = window.sessionStorage.getItem("credits");
    if (credits) {
      data = JSON.parse(credits);
      if (new Date().getTime() - data.when < (60 * 1000)) {
        _this.update({
          credits: data.credits,
          notify_credits: data.notify_credits,
          orghash: data != null ? data.orghash : void 0
        });
        return;
      }
    }
    return xhr("GET", "/duocms/api/team/credits", null, function(res) {
      data = JSON.stringify({
        when: new Date().getTime(),
        credits: res.body.data.credits,
        notify_credits: res.body.data.notify_credits,
        orghash: res.body.data.orghash
      });
      window.sessionStorage.setItem("credits", data);
      return _this.update({
        credits: res.body.data.credits,
        notify_credits: res.body.data.notify_credits,
        orghash: res.body.data.orghash
      });
    });
  };
})(this);

this.updateNotify = (function(_this) {
  return function(e) {
    var notify_credits;
    console.log("updateNotify", e.target.checked);
    notify_credits = e.target.checked;
    if (notify_credits !== _this.notify_credits) {
      return xhr("POST", "/duocms/api/team/credits", {
        notify_credits: notify_credits
      }, function(res) {
        window.sessionStorage.removeItem("credits");
        return _this.getCredits();
      });
    }
  };
})(this);

this.loadlist = (function(_this) {
  return function() {
    _this.update({
      loading: true
    });
    _this.password = "";
    return resource.get(function(team) {
      _this.team = team;
      _this.loading = false;
      return _this.update();
    });
  };
})(this);

this.loadinvoices = (function(_this) {
  return function() {
    _this.update({
      loading: true
    });
    return inv_resource.get(function(invoices) {
      _this.invoices = invoices.reverse();
      _this.loading = false;
      return _this.update();
    });
  };
})(this);

this.makeinv_page = (function(_this) {
  return function(page_invoices) {
    _this.page_invoices = page_invoices;
    return _this.update();
  };
})(this);

this.get = (function(_this) {
  return function(e) {
    var user;
    user = e.item;
    _this.update({
      user: null,
      loading: true
    });
    _this.password = "";
    _this.pwfield = "text";
    return resource.get({
      id: user.id
    }, function(user1, err) {
      _this.user = user1;
      _this.err = err;
      _this.loading = false;
      _this.password = null;
      return _this.update();
    });
  };
})(this);

this.get_invoice = (function(_this) {
  return function(e) {
    var invoice;
    invoice = e.item;
    return window.open("/duocms/api/team_invoices/" + invoice.id);
  };
})(this);

this.save = (function(_this) {
  return function(e) {
    e.preventDefault();
    _this.saving = true;
    if (_this.password === _this.password2 && _this.password.length > 7) {
      _this.user.password = _this.password;
    }
    return resource.save(_this.user, function(user, err) {
      _this.err = err;
      _this.saving = false;
      if (!_this.err) {
        _this.user = null;
        _this.loadlist();
      }
      return _this.update();
    });
  };
})(this);

this.add = (function(_this) {
  return function() {
    return _this.user = {
      sendinvite: true
    };
  };
})(this);

this.remove = (function(_this) {
  return function() {
    return resource.remove({
      id: _this.user.id
    }, function(user1, err) {
      _this.user = user1;
      _this.err = err;
      if (!_this.err) {
        _this.user = null;
        _this.loadlist();
      }
      return _this.update();
    });
  };
})(this);

this.passupdate = (function(_this) {
  return function(e) {
    return _this.update({
      password: e.target.value
    });
  };
})(this);

this.passupdate2 = (function(_this) {
  return function(e) {
    return _this.update({
      password2: e.target.value
    });
  };
})(this);

this.userupdate = (function(_this) {
  return function(e) {
    if (e.target.type === "checkbox") {
      return _this.user[e.target.name] = e.target.checked;
    } else {
      return _this.user[e.target.name] = e.target.value;
    }
  };
})(this);

this.close = (function(_this) {
  return function() {
    _this.user = null;
    return _this.update();
  };
})(this);

this.settab = (function(_this) {
  return function(e) {
    return _this.update({
      tab: e.target.name
    });
  };
})(this);

this.getCurrency = (function(_this) {
  return function(basketdata) {
    if (!basketdata.currency) {
      return "£";
    }
    switch (basketdata.currency) {
      case "GBP":
        return "£";
      case "EUR":
        return "€";
      case "USD":
        return "$";
      default:
        return "£";
    }
  };
})(this);
});
    
  